import React from 'react';

import ConfirmationDialog from "../molecules/confirmationDialog";
import { CompleteDialog } from "../molecules/completeDialog";
import { GolfHeaderContainer } from '../organisms/golfHeaderContainer';
import { GolfPlanTitleContainer } from '../organisms/golfPlanTitleContainer';
import SavedSearchCriteriaContainer from "../organisms/savedSearchCriteriaContainer";
import { PlayDateContainer } from '../organisms/playDateContainer';
import StartTimeContainer from '../organisms/startTimeContainer';
import GolfSearchConditionsContainer from '../organisms/golfSearchConditionsContainer';
import GolfPlanContainer from '../organisms/golfPlanContainer';
import { GolfResultFooterContainer } from '../organisms/golfResultFooterContiner';
import GolfReservationPopupContainer from '../organisms/golfReservationPopupContainer';
import AreaAndFacilitySelectionContainer from '../organisms/areaAndFacilitySelectionContainer';

class GolfPlanTitleTemplate extends React.Component {

    render() {

        return (
            <div style={{ height: "100%" }}>
                <GolfHeaderContainer 
                    categoryLabel1={"検索結果"} Label categoryLabel2={"RESULT"} 
                    path={"/reserve/golf/search"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}/>
                <ConfirmationDialog
                    state={this.props.state.confirmPopup}
                    onClickOpenConfirm={this.props.onClickOpenConfirm}
                    onClickOpenComplete={this.props.onClickOpenComplete} />
                <CompleteDialog
                    state={this.props.state.completePopup}
                    onClickOpenComplete={this.props.onClickOpenComplete} />
                <GolfPlanTitleContainer
                    onClickConditions={this.props.onClickConditions}
                    onClickOpenSavedSearchCriteriaWindow={this.props.onClickOpenSavedSearchCriteriaWindow}
                    onClickOpenSelectDateWindow={this.props.onClickOpenSelectDateWindow}
                    onClickOpenStartTimeWindow={this.props.onClickOpenStartTimeWindow}
                    onClickOpenSelectAreaWindow={this.props.onClickOpenSelectAreaWindow}
                    onClickOpenConfirm={this.props.onClickOpenConfirm} />
                <SavedSearchCriteriaContainer
                    state={this.props.state.savedSearchCriteriaPopup}
                    onClickOpenSavedSearchCriteriaWindow={this.props.onClickOpenSavedSearchCriteriaWindow} />
                <PlayDateContainer
                    state={this.props.state.PlayDatePopup}
                    onClickOpenSelectDateWindow={this.props.onClickOpenSelectDateWindow}
                    playDateFlg={true} />
                <GolfReservationPopupContainer
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                />
                <StartTimeContainer
                    state={this.props.state.startTimePopup}
                    onClickOpenStartTimeWindow={this.props.onClickOpenStartTimeWindow} />
                <AreaAndFacilitySelectionContainer
                    state={this.props.state.areaSelectionPopup}
                    onClickOpenSelectAreaWindow={this.props.onClickOpenSelectAreaWindow} />

                <div style={{ textAlign: "center" }}>
                    <GolfSearchConditionsContainer
                        onClickOpenSavedSearchCriteriaWindow={this.props.onClickOpenSavedSearchCriteriaWindow}
                        onClickOpenSelectDateWindow={this.props.onClickOpenSelectDateWindow}
                        onClickOpenStartTimeWindow={this.props.onClickOpenStartTimeWindow}
                        onClickOpenSelectAreaWindow={this.props.onClickOpenSelectAreaWindow}
                        onClickOpenConfirm={this.props.onClickOpenConfirm} />
                    <GolfPlanContainer />
                </div>
                <div style={{ marginTop: "50px" }}>
                    <GolfResultFooterContainer />
                </div>
            </div>
        )
    }
}
export default GolfPlanTitleTemplate;